// export { default as Dashboard } from './Dashboard';
export { default as NotFound } from './NotFound';
export { default as Settings } from './Settings';
export { default as SignIn } from './SignIn';
export { default as SignUp } from './SignUp';
export { default as Terms } from './Terms';
export { default as Forgot } from './Terms/Forgot';
export { default as Default } from './Default';
export { default as PTMessage } from './PTMessage';
export { default as PTSchedule } from './PTSchedule';
export { default as Template } from './Template';
export { default as Communication } from './Communications';
export { default as RegisterPractice } from './RegisterPractice';